import React, { useState, useMemo } from "react";

const sampleProducts = [
  {
    id: 1,
    name: "Camiseta UNIFICADOS - Black Flame",
    price: 89.9,
    img: "", // Removi a URL para ativar o visual "Em Breve"
    desc: "Camiseta premium em algodão penteado com estampa exclusiva UNIFICADOS.",
    comingSoon: true,
  },
  {
    id: 2,
    name: "Moletom UNIFICADOS - Ember",
    price: 199.0,
    img: "", 
    desc: "Moletom confortável, interior felpado e acabamento premium.",
    comingSoon: true,
  },
  {
    id: 3,
    name: "Boné UNIFICADOS - Signal",
    price: 59.9,
    img: "", 
    desc: "Boné ajustável com design minimalista e logo bordado.",
    comingSoon: true,
  },
  {
    id: 4,
    name: "Jaqueta UNIFICADOS - Night Runner",
    price: 289.0,
    img: "", 
    desc: "Jaqueta leve resistente à água com corte urbano.",
    comingSoon: true,
  },
];

const ProductCard = ({ p, onOpen }) => (
  <div className="group bg-gradient-to-br from-[#0b0b0b] to-[#0f0f0f] rounded-2xl overflow-hidden shadow-xl transform transition hover:scale-105 relative border border-white/5">
    <div className="relative h-64 w-full bg-[#071227] flex items-center justify-center">
      {/* LÓGICA DE FOTO OU EM BREVE */}
      {p.comingSoon || !p.img ? (
        <div className="flex flex-col items-center justify-center text-center p-6 animate-pulse">
          <div className="w-16 h-16 bg-orange-500/20 rounded-full flex items-center justify-center mb-3 border border-orange-500/30">
            <span className="text-orange-500 font-black text-2xl italic">?</span>
          </div>
          <span className="text-white font-black italic text-xl uppercase tracking-tighter">Em Breve</span>
          <span className="text-gray-600 text-[10px] uppercase font-bold mt-1 tracking-widest">Coleção 2026</span>
        </div>
      ) : (
        <img src={p.img} alt={p.name} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110" />
      )}

      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition flex items-end p-4">
        <button 
          onClick={() => onOpen(p)} 
          className="w-full bg-white text-black font-bold py-2 rounded-lg text-xs uppercase italic"
          disabled={p.comingSoon}
        >
          {p.comingSoon ? "Aguarde o Lançamento" : "Ver Detalhes"}
        </button>
      </div>
      
      {p.comingSoon && (
        <div className="absolute top-3 left-3 bg-orange-500 text-white px-3 py-1 rounded-full font-black text-[10px] shadow-lg italic z-10">EM BREVE</div>
      )}
    </div>
    <div className="p-4">
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-lg font-bold text-white line-clamp-1">{p.name}</h3>
      </div>
      <p className="text-sm text-gray-400 line-clamp-2 h-10">{p.desc}</p>
      <div className="mt-4 flex items-center justify-between pt-4 border-t border-white/5">
        <button 
          onClick={() => onOpen(p)} 
          className={`px-4 py-2 rounded-lg font-bold text-xs uppercase italic transition ${p.comingSoon ? 'bg-gray-800 text-gray-500 cursor-not-allowed' : 'bg-gradient-to-r from-orange-500 to-pink-500 text-white shadow-md hover:brightness-110'}`} 
          disabled={p.comingSoon}
        >
          Ver
        </button>
        <span className="text-white font-black italic">R$ {p.price.toFixed(2)}</span>
      </div>
    </div>
  </div>
);

const Store = () => {
  const [products] = useState(sampleProducts);
  const [selected, setSelected] = useState(null);
  const [cart, setCart] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  const addToCart = (product) => {
    setCart((prev) => {
      const found = prev.find((i) => i.id === product.id);
      if (found) return prev.map((i) => i.id === product.id ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { ...product, qty: 1 }];
    });
  };

  const removeFromCart = (id) => setCart((prev) => prev.filter((i) => i.id !== id));

  const total = useMemo(() => cart.reduce((s, i) => s + i.price * i.qty, 0), [cart]);

  return (
    <div className="min-h-screen text-white py-12 px-4" style={{
      backgroundImage: `radial-gradient(circle at 10% 20%, rgba(255,94,58,0.12), transparent 10%), radial-gradient(circle at 90% 80%, rgba(255,45,85,0.08), transparent 12%), linear-gradient(180deg,#000814 0%,#031124 40%, #07141a 100%)`,
      backgroundBlendMode: 'overlay, overlay, normal',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }}>
      {/* Hero */}
      <section className="max-w-6xl mx-auto mb-12">
        <div className="rounded-3xl overflow-hidden bg-black/40 backdrop-blur-sm p-8 flex flex-col md:flex-row items-center gap-6 border border-white/5 shadow-2xl">
          <div className="flex-1">
            <h1 className="text-5xl md:text-6xl font-black italic uppercase tracking-tight drop-shadow-lg leading-none">Loja Oficial <br/><span className="text-orange-500">UNIFICADOS</span></h1>
            <p className="mt-4 text-gray-300 max-w-xl">Peças pensadas para a comunidade: design urbano, conforto e atitude. Edições limitadas — garanta já a sua.</p>
            <div className="mt-6 flex gap-3">
              <button onClick={() => window.scrollTo({ top: 800, behavior: 'smooth' })} className="bg-gradient-to-r from-orange-500 to-pink-500 px-6 py-3 rounded-full font-bold uppercase italic text-sm shadow-lg hover:scale-105 transition">Ver Produtos</button>
              <button onClick={() => setCartOpen(true)} className="border border-white/10 px-6 py-3 rounded-full font-bold uppercase italic text-sm hover:bg-white/5">Carrinho ({cart.reduce((s,i)=>s+i.qty,0)})</button>
            </div>
          </div>
          <div className="w-full md:w-1/2">
            <div className="aspect-[16/10] rounded-xl overflow-hidden shadow-2xl border border-white/5 bg-[#071227] flex items-center justify-center italic font-black text-gray-700 text-4xl uppercase tracking-tighter">
               Unificados 2026
            </div>
          </div>
        </div>
      </section>

      {/* Products */}
      <section className="max-w-6xl mx-auto">
        <div className="flex items-baseline justify-between mb-8 border-b border-white/5 pb-4">
          <h2 className="text-3xl font-black italic uppercase">Coleção</h2>
          <p className="text-xs text-orange-500 font-bold uppercase tracking-widest">Envio para todo o Brasil</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => (
            <ProductCard key={p.id} p={p} onOpen={(prod) => setSelected(prod)} />
          ))}
        </div>

        {/* Destaque com fotos e nomes EM BREVE */}
        <div className="mt-20 bg-black/30 p-8 rounded-3xl border border-white/5 backdrop-blur-md">
          <h3 className="text-2xl font-black italic uppercase mb-6 flex items-center gap-3">
            <span className="w-8 h-1 bg-orange-500 rounded-full"></span>
            Em breve — Novidades
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {products.slice(0, 3).map((p) => (
              <div key={`soon-${p.id}`} className="flex items-center gap-4 bg-white/5 p-4 rounded-2xl border border-white/5 group hover:border-orange-500/30 transition-all">
                <div className="w-20 h-20 flex-shrink-0 rounded-xl overflow-hidden bg-[#071227] border border-white/10 flex items-center justify-center">
                   <span className="text-orange-500 font-black italic">?</span>
                </div>
                <div>
                  <div className="text-sm font-bold text-white uppercase italic">{p.name}</div>
                  <div className="text-[10px] text-orange-400 font-black tracking-widest mt-1">EM BREVE</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {selected && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/90 backdrop-blur-sm" onClick={() => setSelected(null)}></div>
          <div className="relative max-w-3xl w-full bg-[#0b0b0b] rounded-3xl overflow-hidden shadow-2xl border border-white/10 animate-in zoom-in duration-300">
            <div className="md:flex">
              <div className="md:w-1/2 bg-[#071227] flex items-center justify-center min-h-[300px]">
                {selected.img ? (
                    <img src={selected.img} alt={selected.name} className="object-cover w-full h-full" />
                ) : (
                    <span className="text-gray-800 font-black text-6xl uppercase italic tracking-tighter">Soon</span>
                )}
              </div>
              <div className="p-8 md:w-1/2 flex flex-col justify-center">
                <h3 className="text-3xl font-black italic uppercase mb-2">{selected.name}</h3>
                <p className="text-gray-400 mb-6 leading-relaxed">{selected.desc}</p>
                <div className="mb-8 text-2xl font-black text-orange-500 italic">R$ {selected.price.toFixed(2)}</div>
                <div className="flex gap-3 mt-auto">
                  <button onClick={() => { addToCart(selected); setSelected(null); }} className="flex-1 bg-gradient-to-r from-orange-500 to-pink-500 py-4 rounded-xl font-black uppercase italic shadow-lg shadow-orange-500/20 hover:scale-105 transition">Adicionar ao Carrinho</button>
                  <button onClick={() => setSelected(null)} className="px-6 py-4 border border-white/10 rounded-xl font-bold uppercase text-xs hover:bg-white/5">Fechar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Cart sidebar */}
      <div className={`fixed right-0 top-0 h-full w-full sm:w-96 bg-[#050505] shadow-2xl transform transition-transform duration-500 ease-in-out ${cartOpen ? 'translate-x-0' : 'translate-x-full'} z-[100] border-l border-white/10`}>
        <div className="p-8 flex flex-col h-full">
          <div className="flex items-center justify-between mb-8">
            <h4 className="text-2xl font-black italic uppercase tracking-tighter">Seu Carrinho</h4>
            <button onClick={() => setCartOpen(false)} className="bg-white/5 p-2 rounded-full hover:bg-white/10 transition text-gray-400">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 6L6 18M6 6l12 12"/></svg>
            </button>
          </div>
          <div className="flex-1 overflow-y-auto space-y-6">
            {cart.length === 0 ? (
              <div className="text-center py-20">
                  <div className="text-gray-700 font-black text-5xl mb-4 italic opacity-20 uppercase">Vazio</div>
                  <p className="text-gray-500 font-bold uppercase text-xs tracking-widest">Adicione produtos para continuar</p>
              </div>
            ) : (
              cart.map((item) => (
                <div key={item.id} className="flex items-center gap-4 bg-white/5 p-3 rounded-xl">
                  <div className="w-16 h-16 bg-[#071227] rounded-lg overflow-hidden flex items-center justify-center">
                      {item.img ? <img src={item.img} alt={item.name} className="object-cover w-full h-full" /> : <span className="text-orange-500 font-black italic">?</span>}
                  </div>
                  <div className="flex-1">
                    <div className="font-bold text-sm uppercase italic line-clamp-1">{item.name}</div>
                    <div className="text-xs text-gray-400 font-bold">{item.qty} x R$ {item.price.toFixed(2)}</div>
                  </div>
                  <div className="text-right">
                    <button onClick={() => removeFromCart(item.id)} className="text-[10px] font-black uppercase text-rose-500 hover:underline">Remover</button>
                  </div>
                </div>
              ))
            )}
          </div>
          <div className="mt-auto border-t border-white/10 pt-6">
            <div className="flex justify-between items-center mb-6">
              <span className="text-gray-500 font-bold uppercase text-xs">Total do Pedido</span>
              <span className="text-2xl font-black italic text-white">R$ {total.toFixed(2)}</span>
            </div>
            <div className="grid grid-cols-1 gap-3">
              <button onClick={() => { setCart([]); setCartOpen(false); }} disabled={cart.length===0} className="w-full bg-gradient-to-r from-orange-500 to-pink-500 py-4 rounded-xl font-black uppercase italic shadow-lg shadow-orange-500/20 disabled:opacity-30">Finalizar Compra</button>
              <button onClick={() => setCart([])} className="w-full py-3 text-xs font-bold text-gray-500 uppercase tracking-widest hover:text-white transition">Limpar Tudo</button>
            </div>
          </div>
        </div>
      </div>

      {/* Floating cart button */}
      <button onClick={() => setCartOpen(true)} className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-orange-500 to-pink-500 text-white px-6 py-4 rounded-2xl shadow-2xl flex items-center gap-3 hover:scale-110 transition active:scale-95 group">
        <div className="relative">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4" strokeLinecap="round" strokeLinejoin="round"></path><circle cx="10" cy="20" r="1"/><circle cx="20" cy="20" r="1"/></svg>
            <span className="absolute -top-2 -right-2 bg-white text-orange-500 w-5 h-5 rounded-full text-[10px] font-black flex items-center justify-center border-2 border-orange-500">{cart.reduce((s,i)=>s+i.qty,0)}</span>
        </div>
        <span className="font-black italic uppercase text-xs tracking-tighter">Carrinho</span>
      </button>
    </div>
  );
};

export default Store;
